import * as actionTypes from "../actions/actionTypes";

const nftReducer = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_COLLECTION:
      return {
        ...state,
        collection: { ...(state?.collection || {}), ...action.payload },
      };
    case actionTypes.SET_NEW_COLLECTION:
      return {
        ...state,
        newCollection: { ...(state?.newCollection || {}), ...action.payload },
      };
    case actionTypes.SET_TOP_MINT:
      return {
        ...state,
        topMints: { ...(state?.topMints || {}), ...action.payload },
      };
    case actionTypes.SET_TOP_NFT:
      return {
        ...state,
        topNft: { ...(state?.topNft || {}), ...action.payload },
      };
    default:
      return state;
  }
};

export default nftReducer;
